module.exports = __webpack_public_path__ + "img/P15-en.6fdfe1f4.png";